import {
  createFileRoute,
  useNavigate,
  useSearch,
} from "@tanstack/react-router";
import { Route as ProductGroupRoute } from "./cooling-regimes-product-group";
import { DetailDrawer } from "../components/DetailDrawer";
import { useMemo } from "react";
import { getCoolingRegimeProductGroupDetailTabs } from "../components/CoolingRegimeProductGroup/getCoolingRegimeProductGroupDetailTabs";

export const Route = createFileRoute("/cooling-regimes-product-group/$id")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const search = useSearch({ from: "/cooling-regimes-product-group/$id" });
  const { id } = Route.useParams();

  console.log("Detail route component rendered");
  console.log("Param ID from useParams:", id);

  const drawerOpen = !!id;

  const tabs = useMemo(() => {
    return id ? getCoolingRegimeProductGroupDetailTabs(id) : [];
  }, [id]);

  return (
    <DetailDrawer
      open={drawerOpen}
      onClose={() => {
        navigate({
          to: ProductGroupRoute.fullPath,
          from: "/cooling-regimes-product-group",
          search,
        });
      }}
      tabs={tabs}
    />
  );
}
